import { render, staticRenderFns } from "./error.vue?vue&type=template&id=ea0f4bb0&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=ea0f4bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0f4bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0f4bb0')) {
      api.createRecord('ea0f4bb0', component.options)
    } else {
      api.reload('ea0f4bb0', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=ea0f4bb0&scoped=true&", function () {
      api.rerender('ea0f4bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/error.vue
// module id = Zazt
// module chunks = 0